import axiosInstance from "@/composables/axios-instance";
import router from "@/router";
import { toast } from "vue3-toastify";

const state = {
  employees: [],
  assetsList: [],
  categoriesList: [],
  statusList: [],
  assetDetail: {},
  showList: true,
  logs:[]
};

const getters = {
  getEmployeesList(state) {
    return state.employees;
  },
  getAssetsList(state) {
    return state.assetsList;
  },
  getCategoriesList(state) {
    return state.categoriesList;
  },
  getStatusList(state) {
    return state.statusList;
  },
  getShelvesList(state) {
    return state.shelvesList;
  },
  getUnitsList(state) {
    return state.unitsList;
  },
  getAssetDetail(state) {
    return state.assetDetail;
  },
  getShowList(state) {
    return state.showList;
  },
  getAssetLogList(state){
    return state.logs;
  }
};

const mutations = {
  setAssetsList(state, list) {
    state.assetsList = list;
  },
  setCategoriesList(state, list) {
    state.categoriesList = list;
  },
  setStatusList(state, list) {
    state.statusList = list;
  },
  setShelvesList(state, list) {
    state.shelvesList = list;
  },
  setUnitsList(state, list) {
    state.unitsList = list;
  },
  setAssetDetail(state, detail) {
    state.assetDetail = detail;
  },
  setShowList(state, showList) {
    state.showList = showList;
  },
  setEmployeesList(state, data) {
    state.employees = data;
  },
  setAssetsLog(state, list){
    state.logs = list;
  }
};

const actions = {
  getListOfEmployeesFromApi({ commit }) {
    return axiosInstance
      .get("/report/subsetlist/")
      .then((response) => {
        commit("setEmployeesList", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  getAssetsListFromApi({ commit }, filter) {
    return axiosInstance
      .get("/get/", {
        params: {
          persian_name: filter.persian_name,
          assets_number: filter.assets_number,
          category: filter.category,
          date_range: filter.date_range,
          space_id: filter.space_id,
          status: filter.status,
          page: filter.page,
          assigned_to: filter.assigned_to,
          page_size: 60,
        },
      })
      .then((response) => {
        commit("setAssetsList", response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  getMyAssetsListFromApi({ commit }, filter) {
    return axiosInstance
      .get("/get/my/", {
        params: {
          persian_name: filter.persian_name,
          assets_number: filter.assets_number,
          category: filter.category,
          date_range: filter.date_range,
          space_id: filter.space_id,
          status: filter.status,
          page: filter.page,
          page_size: 60,
        },
      })
      .then((response) => {
        commit("setAssetsList", response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  getCategoriesListFromApi({ commit }) {
    return axiosInstance
      .get("/category/get/")
      .then((response) => {
        commit("setCategoriesList", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  getStatusListFromApi({ commit }) {
    return axiosInstance
      .get("/status/get/")
      .then((response) => {
        commit("setStatusList", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  /* eslint-disable */
  createAsset({}, asset) {
    let assetData = {};
    for (let key in asset) {
      if (key === 'custom_fields') {
        assetData[key] = JSON.stringify(asset[key] || {});
      } else {
        assetData[key] = asset[key];
      }
    }
    return axiosInstance
      .postForm("/create/", assetData)
      .then((response) => {
        toast.success("کالا(ها) با موفقیت ایجاد شد");
      })
      .catch((error) => {
        toast.error("کالا ساخته نشد لطفا بعدا تلاش کنید");
        console.error(error);
      });
  },

  deleteAsset({}, id) {
    return axiosInstance
      .delete("/delete/", { params: { id } })
      .then((response) => {
        toast.success("کالا با موفقیت حذف شد");
      })
      .catch((error) => {
        toast.error("در حذف کالا مشکلی پیش آمده لطفا بعدا تلاش کنید");
      });
  },

  getAssetDetailFromApi({ commit }, id) {
    return axiosInstance
      .get("/get/detail/", { params: { id } })
      .then((response) => {
        commit("setAssetDetail", response.data);
      })
      .catch((error) => {
        toast.error("اطلاعات کالای مورد نظر یافت نشد");
      });
  },
  updateAssetDetail({}, { id, asset }) {
    let requestData = {};
    for (let key in asset) {
      if (key === 'custom_fields') {
        requestData[key] = JSON.stringify(asset[key] || {});
      } else if (asset[key] != "") {
        requestData[key] = asset[key];
      }
    }
    requestData.id = id;
    return axiosInstance
      .putForm(`/update/`, requestData)
      .then((response) => {
        router.push({ name: "manageAssets", query: { edit: "success" } });
      })
      .catch((error) => {
        toast.error("اطلاعات تغییر نیافت لطفا بعدا تلاش کنید");
        console.error(error);
      });
  },

  updateAssetsGroup({}, asset) {
    let requestData = {};
    for (let key in asset) {
      if (key === 'custom_fields') {
        if (asset[key] && typeof asset[key] === 'object') {
          const cleanCustomFields = {};
          for (let cfKey in asset[key]) {
            const val = asset[key][cfKey];
            if (val !== '' && val !== null && val !== undefined) {
              cleanCustomFields[cfKey] = val;
            }
          }
          if (Object.keys(cleanCustomFields).length > 0) {
            requestData[key] = JSON.stringify(cleanCustomFields);
          }
        }
      } else if (asset[key] != "") {
        requestData[key] = asset[key];
      }
    }
    return axiosInstance
      .putForm(`/update/`, requestData)
      .then((response) => {
        toast.success("اطلاعات با موفقیت تغییر یافت");
      })
      .catch((error) => {
        toast.error("اطلاعات تغییر نیافت لطفا بعدا تلاش کنید");
        console.error(error);
      });
  },
  getAssetsLog({ commit }, asset_id) {
    return axiosInstance
      .get("/log/get/", { params: { asset_id } })
      .then((response) => {
        commit("setAssetsLog", response.data);
      })
      .catch((error) => {
        toast.error("گردش کالا دریافت نشد.");
        console.error(error);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
